import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faq } from '../../data/faq';
export function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faq[0].id);
  return <section id="questions" className="bg-white py-20 lg:py-28" data-id="element-59" data-mp="1d8hhi0a2udnn">
      <div className="mx-auto grid max-w-shell gap-12 px-5 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20 lg:px-8" data-id="element-60" data-mp="1i8m2o3lxjwk7">
        <div data-id="element-61" data-mp="13jzkzv8tyspt">
          <h2 className="ffp-display text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-62" data-mp="13jhfs946x45r">Les questions qu’on nous pose</h2>
          <p className="mt-4 text-[16px] leading-relaxed text-ink/65" data-id="element-63" data-mp="18b7vkulwck4k">
            Une question qui n’y figure pas ? Les délégués fédéraux de votre département y répondent.
          </p>
        </div>

        <dl className="border-t border-line" data-id="element-64" data-mp="ylfxhqel98vc">
          {faq.map(item => {
          const open = openId === item.id;
          return <div key={item.id} className="border-b border-line" data-id="element-65" data-mp="pjylaj4axrbx">
                <dt data-id="element-66" data-mp="pjeyop3pierk">
                  <button type="button" onClick={() => setOpenId(open ? null : item.id)} aria-expanded={open} className="ffp-focus flex w-full items-center justify-between gap-6 py-5 text-left" data-id="element-67" data-mp="plsw34lv032a">
                    <span className="ffp-display text-[17px] font-bold text-ink lg:text-[19px]" data-id="element-68" data-mp="v8gnochg9kwl">
                      {item.question}
                    </span>
                    {open ? <MinusIcon className="h-5 w-5 shrink-0 text-navy" aria-hidden="true" data-id="element-69" data-mp="2jt0gbd54lge" /> : <PlusIcon className="h-5 w-5 shrink-0 text-ink/40" aria-hidden="true" data-id="element-70" data-mp="cboxrk7ek7jk" />}
                  </button>
                </dt>
                {open && <dd className="max-w-2xl pb-6 text-[15px] leading-relaxed text-ink/70" data-id="element-71" data-mp="7j5k6n8ptcer">{item.answer}</dd>}
              </div>;
        })}
        </dl>
      </div>
    </section>;
}